export default __webpack_public_path__ + "static/media/broadcast.44d3a367.svg";